var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCurriculumEmptystate = function SvgCurriculumEmptystate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.972 91.307c-.093 2.931-2.584 5.51-5.518 5.677-13.651.76-27.302.76-40.953 0-2.934-.168-5.426-2.746-5.518-5.677-.572-18.815-.621-37.63-.149-56.445.077-2.932 2.572-5.485 5.527-5.628a437.664 437.664 0 0 1 41.233 0c2.954.144 5.45 2.696 5.527 5.628.472 18.815.423 37.63-.149 56.445Z",
    fill: "url(#curriculum-emptystate_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M33.513 61.57c.012 9.913.168 19.825.469 29.737.093 2.931 2.584 5.51 5.518 5.677 13.651.76 27.302.76 40.953 0-3.651-.278-7.31-.62-10.977-1.017-17.72-1.994-32.608-16.859-35.963-34.396Z",
    fill: "url(#curriculum-emptystate_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M59.978 34.223a5.376 5.376 0 0 1-5.378-5.442c.022-3.019 2.432-5.508 5.378-5.509 2.946 0 5.356 2.49 5.378 5.509a5.376 5.376 0 0 1-5.378 5.442Z",
    fill: "url(#curriculum-emptystate_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.907 62.801c-.018 9.585-.141 19.17-.37 28.754-9.561.45-19.123.588-28.684.411 9.472-9.534 19.303-19.545 29.054-29.165Z",
    fill: "url(#curriculum-emptystate_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.243 34.625c-.375 18.99-.336 37.979.117 56.968 4.183.197 8.366.334 12.55.412 2.226.041 4.238-.859 5.698-2.337a8.248 8.248 0 0 0 2.369-5.802V73.828a2.739 2.739 0 0 1 2.732-2.74c3.34-.007 6.678-.027 10.018-.059a8.355 8.355 0 0 0 5.81-2.444c1.492-1.484 2.422-3.514 2.426-5.746.018-9.404-.066-18.81-.252-28.214a535.103 535.103 0 0 0-41.468 0Z",
    fill: "url(#curriculum-emptystate_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.619 88.431a8.53 8.53 0 0 0 1.317-4.572V73.637c0-1.54 1.223-2.788 2.732-2.79 3.34-.008 6.679-.027 10.018-.06 2.07-.02 3.966-.824 5.417-2.117L58.619 88.431Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.914 31.687c-1.3-.037-2.6-.07-3.9-.097a2.795 2.795 0 0 1-2.574-1.915l-.385-1.15c-1.044-3.113-3.89-5.254-7.077-5.253-3.186 0-6.032 2.14-7.076 5.253l-.385 1.15a2.794 2.794 0 0 1-2.574 1.915c-1.3.027-2.6.06-3.9.097a1.43 1.43 0 0 0-1.37 1.398c-.027 1.81-.052 3.62-.074 5.43-.01.749.592 1.343 1.342 1.327a682.836 682.836 0 0 1 28.075 0 1.305 1.305 0 0 0 1.342-1.328c-.022-1.81-.047-3.62-.075-5.429a1.43 1.43 0 0 0-1.37-1.398Zm-13.936-.202c-1.49 0-2.694-1.218-2.689-2.729.006-1.511 1.21-2.746 2.69-2.746 1.479 0 2.683 1.235 2.688 2.746.006 1.512-1.198 2.73-2.689 2.73Z",
    fill: "url(#curriculum-emptystate_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.469 69.191c-2.268-.129-13.433-2.304-13.435-2.315-3.67-.64-6.727 2.568-6.259 6.265 0 0 1.325 11.18 1.497 13.456.118 1.547-.346 2.998-1.114 4.23a8.003 8.003 0 0 0 1.45-1.16 8.247 8.247 0 0 0 2.369-5.8V73.827a2.739 2.739 0 0 1 2.732-2.74c3.34-.007 6.679-.027 10.018-.058a8.35 8.35 0 0 0 5.72-2.358c-.927.383-1.931.587-2.978.52Z",
    fill: "url(#curriculum-emptystate_svg__g)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "curriculum-emptystate_svg__a",
    x1: 96.279,
    y1: 25.765,
    x2: 20.604,
    y2: 100.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "curriculum-emptystate_svg__b",
    x1: 38.377,
    y1: 97.884,
    x2: 73.582,
    y2: 62.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "curriculum-emptystate_svg__d",
    x1: 54.257,
    y1: 68.143,
    x2: 89.513,
    y2: 96.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "curriculum-emptystate_svg__e",
    x1: 17.22,
    y1: 84.08,
    x2: 91.026,
    y2: 43.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.393
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "curriculum-emptystate_svg__f",
    x1: 50.668,
    y1: 45.149,
    x2: 79.064,
    y2: 16.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "curriculum-emptystate_svg__g",
    x1: 73.042,
    y1: 66.719,
    x2: 56.304,
    y2: 85.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "curriculum-emptystate_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.978 28.748) scale(5.42706)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })))));
};

export default SvgCurriculumEmptystate;